<template>
    <div class="card">
        <div class="card-body p-4">
            <!-- Header -->
            <div class="d-flex mb-3 mt-n2 me-n3 justify-content-between align-items-center">
                <p class="text-muted m-0 fs-sm">Last updated: {{ helper.dateFormatter(survey.updated_at) }}</p>
                <a class="text-decoration-none" data-bs-toggle="dropdown" aria-expanded="false" role="button">
                    <i class="hoverable-icon small-icon bi-three-dots-vertical" v-ripple></i>
                </a>
                <ul class="dropdown-menu">
                    <li>
	                    <a class="dropdown-item cursor-pointer" v-load-page="{ name: 'single_survey', params: { 'id': survey.uuid } }" v-ripple>
		                    <i class="me-3 bi bi-eye"></i>
		                    View
	                    </a>
<!--                        <a v-if="!survey.is_completed && survey.status !== 'processing'" class="dropdown-item cursor-pointer" v-load-page="{ name: 'Survey', params: { 'id': survey.uuid, 'type': 'identified' } }" v-ripple>-->
<!--	                        <i class="me-3 bi bi-pencil"></i>-->
<!--                            Edit-->
<!--                        </a>-->
                        <a @click="emits('downloadSurvey', survey.uuid)" v-ripple class="dropdown-item cursor-pointer">
                            <i class="me-3 bi bi-cloud-arrow-down"></i>
                            Download
                        </a>
                        <a v-if="survey.status !== 'processing'" @click="emits('deleteSurvey', survey.uuid)" v-ripple class="dropdown-item cursor-pointer">
                            <i class="me-3 bi bi-trash"></i>
                            Delete
                        </a>
                    </li>
                </ul>
            </div>
            <!-- Medication Row -->
            <div class="d-flex gap-2 align-items-center mb-4">
                <img class="thumb"
                    src="https://images.pexels.com/photos/13779107/pexels-photo-13779107.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" />
                <div class="d-flex flex-column">
                    <p class="m-0 fw-semibold" v-max-lines="1">{{ medicationName }}</p>
                    <p class="m-0 mt-1 text-muted fs-sm" v-max-lines="2">This large text would span two lines max. 404
                        words
                        not found</p>
                </div>
            </div>
            <!-- Condition Row -->
            <div class="d-flex gap-2 align-items-center mb-4">
                <img class="thumb"
                    src="https://images.pexels.com/photos/13430311/pexels-photo-13430311.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" />
                <div class="d-flex flex-column">
                    <p class="m-0 fw-semibold" v-max-lines="1">{{ survey.surveyable_name }}</p>
                    <p class="m-0 mt-1 text-muted fs-sm" v-max-lines="2">This large text would span two lines max. 404 words not found</p>
                </div>
            </div>
            <!-- Progress -->
            <p class="text-muted subhead m-0">PROGRESS</p>
            <p class="fs-4 mb-2 fw-semibold">{{ percentCompleted }}%</p>
            <div class="progress">
                <div :style="'width: ' + percentCompleted + '%;'" class="progress-bar bg-success" role="progressbar"
                    aria-label="Survey Progress" :aria-valuenow="percentCompleted" aria-valuemin="0"
                    aria-valuemax="100">
                </div>
            </div>
            <!-- Resume Button -->
            <button v-if="survey.is_completed !== 1 && survey.status !== 'processing'" type="button"
                    class="btn btn-dark rounded-pill w-100 px-3 mt-4" v-load-page="{ name: 'Survey', params: { 'id': survey.uuid, 'type': 'identified' } }"
                    v-ripple>Resume</button>
        </div>

        <!-- Resume Modal -->
        <div class="modal fade" tabindex="-1" id="resumeModal" aria-labelledby="resumeModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered sheetModal popOutModal">
                <div class="modal-content rounded-sm">
                    <div class="modal-body d-flex flex-column py-4">
                        <p class="fs-4 fw-semibold mb-2">Survey Title</p>
                        <p class="mb-2 text-secondary mb-4">Some description</p>
                        <div class="mb-2 d-flex align-items-center w-100">
                            <input class="form-check-input mt-0" id="termsCheck" type="checkbox" name="termsCheck">
                            <label class="form-check-label cursor-pointer p-2 flex-grow-1" for="termsCheck">
                                Agree to terms
                            </label>
                        </div>
                        <div class="mb-4 d-flex align-items-center w-100">
                            <input class="form-check-input mt-0" id="privacyCheck" type="checkbox" name="privacyCheck">
                            <label class="form-check-label cursor-pointer p-2 flex-grow-1" for="privacyCheck">
                                Agree to privacy
                            </label>
                        </div>
                        <button class="btn btn-dark py-7 rounded-pill w-100 mb-sm-3" v-load-page="'/survey'" v-ripple
                            data-bs-dismiss="modal">Start
                            Survey</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useAppHelpers } from '@/composables/useAppHelpers';

const helper = useAppHelpers();

const props = defineProps({
    survey: Object
});

const emits = defineEmits([
    'downloadSurvey', 'deleteSurvey'
])

onMounted(() => {
    let modalEl = document.querySelector('#resumeModal');
    modalEl.addEventListener('hide.bs.modal', () => {
        modalEl.querySelector('.modal-dialog').classList.add('closing');
        setTimeout(() => {
            modalEl.querySelector('.modal-dialog').classList.remove('closing');
        }, 500)
    })
});

const medicationName = computed(() => {
    if (props.survey.brand_name) {
        return props.survey.brand_name + ' (' + props.survey.medication_name + ')';
    }
    else {
        return props.survey.medication_name;
    }
});

const percentCompleted = computed(() => {
	if(props.survey.is_completed === 1) {
		return 100;
	}
    if (props.survey.questions_count) {
        return ((props.survey.last_attempted_qs / props.survey.questions_count) * 100).toFixed(2);
    }
    return 0;
});



</script>

<style scoped lang="scss">
@import '../../assets/scss/variables.scss';

.card {
    border-radius: 15px;

    .subhead {
        font-size: 0.75em;
        letter-spacing: .05em;
        font-weight: 500;
    }

    .card-body {
        border-radius: inherit;
        border: 1px solid #dee2e6;
        user-select: none;

        &:hover {
            box-shadow: rgba(0, 0, 0, 0.09) 0px 0px 6px 0px
        }

        .thumb {
            width: 64px;
            height: auto;
            object-fit: cover;
            border-radius: 15px;
        }

        button {
            padding-top: 0.7em;
            padding-bottom: 0.7em;
            letter-spacing: 0.03em;
            text-transform: uppercase;
            font-weight: 500;
        }
    }

}
</style>